import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, StarRating, Button, ModalWrapper, TextBox } from '../common';
import { formatDateTimeLocale } from '../../utils/formatDate';
import { getBadgeServiceType } from '../../constants/serviceLabels';

export default function ReviewRegisterModal({ reservation, onClose, onSubmit, submitting = false }) {
  const { t } = useTranslation();
  const [rating, setRating] = useState(5);
  const [text, setText] = useState('');

  const ratingOptions = [
    { value: 5, label: `5 ${t('common.point')}` },
    { value: 4, label: `4 ${t('common.point')}` },
    { value: 3, label: `3 ${t('common.point')}` },
    { value: 2, label: `2 ${t('common.point')}` },
    { value: 1, label: `1 ${t('common.point')}` },
  ];

  const writeDate = formatDateTimeLocale(new Date());

  return (
    <ModalWrapper onClose={onClose} padding="p-5 sm:p-8" gap="gap-5">
      {/* Header */}
      <h2 className="text-lg font-bold text-mono-900">{t('common.review_register_title')}</h2>

      {/* Review info */}
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <Badge variant="service" serviceType={getBadgeServiceType(reservation.service_type || reservation.serviceType)}>{reservation.service}</Badge>
          <StarRating rating={rating} />
          <span className="text-2sm font-bold text-mono-900">{rating.toFixed(1)}</span>
        </div>

        <p className="text-md font-bold text-mono-900">{reservation.title}</p>

        <div className="flex flex-col gap-1">
          <p className="text-2sm text-mono-500">
            <span className="inline-block w-[72px]">{t('common.reservation_no_label')}</span>{reservation.reservationNo}
          </p>
          <p className="text-2sm text-mono-500">
            <span className="inline-block w-[72px]">{t('common.usage_datetime_label')}</span>{reservation.scheduledDate || reservation.usageDate}
          </p>
          <p className="text-2sm text-mono-500">
            <span className="inline-block w-[72px]">{t('common.created_at_label')}</span>{writeDate}
          </p>
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-mono-100" />

      {/* 후기 별점 */}
      <TextBox
        variant="select"
        label={t('common.review_rating')}
        value={rating}
        onChange={(e) => setRating(Number(e.target.value))}
        options={ratingOptions}
      />

      {/* 후기 글 */}
      <TextBox
        variant="textarea"
        label={t('common.review_text')}
        placeholder={t('common.review_write_placeholder')}
        value={text}
        onChange={(e) => setText(e.target.value)}
        rows={5}
      />

      {/* Bottom buttons */}
      <div className="flex gap-3">
        <Button level="level3" fullWidth onClick={onClose} disabled={submitting}>{t('common.cancel')}</Button>
        <Button level="level1" fullWidth onClick={() => onSubmit({ rating, text })} disabled={!text.trim() || submitting}>
          {submitting ? t('common.registering') : t('common.register')}
        </Button>
      </div>
    </ModalWrapper>
  );
}
